import request from '@/api/request';
import type { components } from '@/api/API';
import type { EntryTypes } from '@/pages/EntryData/hooks/useEntryPage';

// 添加
export const standardApi = (body: components['schemas']['StandardCreateRequest']) =>
  request.standard.post<string>(body);

export const caseApi = (body: components['schemas']['CaseCreateRequest']) =>
  request.case.post<string>(body);

export const labApi = (body: components['schemas']['LabCreateRequest']) =>
  request.lab.post<string>(body);

export const assistanceApi = (body: components['schemas']['AssistanceCreateRequest']) =>
  request.assistance.post<string>(body);

export const evaluationApi = (body: components['schemas']['EvaluationCreateRequest']) =>
  request.evaluation.post<string>(body);

export const surgeryApi = (body: components['schemas']['SurgeryCreateRequest']) =>
  request.surgery.post<string>(body);

export const dischargeApi = (body: components['schemas']['DischargeCreateRequest']) =>
  request.discharge.post<string>(body);

export const clinicApi = (body: components['schemas']['ClinicCreateRequest']) =>
  request.clinic.post<string>(body);

export const followupApi = (body: components['schemas']['FollowupCreateRequest']) =>
  request.followupThirty.post<string>(body);

export const followup3Api = (body: components['schemas']['Followup3CreateRequest']) =>
  request.followupThreemonth.post<string>(body);

export const followup6Api = (body: components['schemas']['Followup6CreateRequest']) =>
  request.followupSixmonth.post<string>(body);

export const followup12Api = (body: components['schemas']['Followup12CreateRequest']) =>
  request.followupOneyear.post<string>(body);

// 编辑
export const caseUpdate = (body: components['schemas']['CaseUpdateRequest']) =>
  request.case.patch<string>(body);

export const labUpdate = (body: components['schemas']['LabUpdateRequest']) =>
  request.lab.patch<string>(body);

export const assistanceUpdate = (body: components['schemas']['AssistanceUpdateRequest']) =>
  request.assistance.patch<string>(body);

export const evaluationUpdate = (body: components['schemas']['EvaluationUpdateRequest']) =>
  request.evaluation.patch<string>(body);

export const surgeryUpdate = (body: components['schemas']['SurgeryCreateRequest']) =>
  request.surgery.patch<string>(body);

export const dischargeUpdate = (body: components['schemas']['DischargeUpdateRequest']) =>
  request.discharge.patch<string>(body);

export const clinicUpdate = (body: components['schemas']['ClinicUpdateRequest']) =>
  request.clinic.patch<string>(body);

export const followupUpdate = (body: components['schemas']['FollowupUpdateRequest']) =>
  request.followupThirty.put<string>(body);
export const followupUpdate3 = (body: components['schemas']['Followup3UpdateRequest']) =>
  request.followupThreemonth.put<string>(body);
export const followupUpdate6 = (body: components['schemas']['Followup6UpdateRequest']) =>
  request.followupSixmonth.put<string>(body);
export const followupUpdate12 = (body: components['schemas']['Followup12UpdateRequest']) =>
  request.followupOneyear.put<string>(body);

// get

export const caseGet = (body: string) => request.case$.get<string>(body);

export const labGet = (body: string) => request.lab$.get<string>(body);

export const assistanceGet = (body: string) => request.assistance$.get<string>(body);

export const evaluationGet = (body: string) => request.evaluation$.get<string>(body);

export const surgeryGet = (body: string) => request.surgery$.get<string>(body);

export const dischargeGet = (body: string) => request.discharge$.get<string>(body);

export const clinicGet = (body: string) => request.clinic$.get<string>(body);

export const followupGet = (body: string) => request.followup$.get<string>(body);

export const standardGet = (body: string) => request.standard$.get<string>(body);

// 提交质疑

export const challengeAPi = (body: {
  hubId: number;
  property: string;
  entity: string | undefined;
  content: string;
}) => request.challenge.post<string>(body);

// get质疑

export const getQuestionAPI = (body: string) => request.challenge$.get<string>(body);

export const doneQuestionApi = (body: {
  hubId: number;
  property: string;
  entity: string | undefined;
}) => request.challengeDone.post<string>(body);

export const deleteQuestions = (body: EntryTypes[]) => request.challengeRemove.post<string>(body);

// 操作日志

export const getOperationLogApi = (body: string) => request.commonOperationlog$.get<string>(body);

// 锁定
export const saveLockAPI = (body: components['schemas']['LockRequest']) =>
  request.commonLock.post<string>(body);

// get 锁定
export const getLockAPI = (body: string) => request.commonLock$.get<string>(body);
